var _path, _circle, _circle2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0859 11.4561H9.92776M2.06438 11.534L1.26909 11.4771C1.10111 11.465 0.967168 11.332 0.954032 11.1641L0.843428 9.75024L0.843396 8.13755C0.843389 7.78824 1.11302 7.49815 1.46141 7.47265L2.40232 7.4038C2.6472 7.38588 2.8724 7.26308 3.02008 7.06693L4.12995 5.59286C4.34692 5.3047 4.64718 5.09015 4.9901 4.97827V4.97827C6.36232 4.53053 7.82929 4.45777 9.23909 4.76752L9.48272 4.82105C10.2389 4.9872 10.9069 5.42731 11.3579 6.05658L12.2542 7.30707C12.2852 7.35026 12.3345 7.37651 12.3876 7.37805L14.2179 7.43108C15.3235 7.46312 16.1932 8.38654 16.159 9.49214L16.1033 11.2912C16.1005 11.3831 16.0251 11.4562 15.9332 11.4562H14.8609",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.57642,
    cy: 11.6169,
    r: 1.5,
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4199,
    cy: 11.6172,
    r: 1.50195,
    stroke: "currentColor",
    strokeWidth: 0.750977
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2189 7.38396L7.01891 7.54479C5.99607 7.47834 5.13692 7.27289 4.94725 7.20653",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6743 5.64309L8.18969 7.45445",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarOutline);
export default __webpack_public_path__ + "static/media/car-outline.e889c76c71213f99db497d4d67f5a7d7.svg";
export { ForwardRef as ReactComponent };